module.exports = __webpack_public_path__ + "img/app-link-google-play.2f5a9206.png";